import React from 'react'
import {
  FacebookShareButton,
  TelegramShareButton,
  WhatsappShareButton,
} from 'react-share'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { Icon } from '@wartek-id/icon'
import { List, ListItem } from '@wartek-id/list'
import { Text } from '@wartek-id/text'
import { useToast } from '@wartek-id/toast'

import { ProfileResponsiveSheet } from 'app/ProfileRevampPage/components/ProfileResponsiveSheet'
import { getUrlsFromText } from 'utils/text'

import FacebookIcon from 'assets/icons/facebook-square.svg'
import TelegramIcon from 'assets/icons/telegram-square.svg'
import WhatsappIcon from 'assets/icons/whatsapp-square.svg'

export type TProfileSocialFunnel =
  | 'whatsapp'
  | 'facebook'
  | 'telegram'
  | 'clipboard'

type TProfileSocialShareDrawerProps = {
  isOpen: boolean
  onClose: () => void
  shareUrl: string
  shareText?: string
  title?: string
  linkOnlyUrl?: string
  linkOnlyOnCopy?: boolean
  onShareButtonClicked?: (socialFunnel: TProfileSocialFunnel) => void
}

export const ProfileSocialShareDrawer = ({
  isOpen,
  onClose,
  shareUrl,
  shareText,
  linkOnlyUrl,
  linkOnlyOnCopy = false,
  title = 'Bagikan',
  onShareButtonClicked = () => {},
}: TProfileSocialShareDrawerProps) => {
  const toast = useToast()
  const shareUrls = getUrlsFromText(shareText) || []

  const onClickShareButton = (funnel: TProfileSocialFunnel) => {
    onShareButtonClicked(funnel)
    onClose()
  }

  return (
    <ProfileResponsiveSheet isOpen={isOpen} onClose={onClose} title={title}>
      <div className="px-2 pb-2 lg:px-4 lg:pb-4">
        <List type="menu" bold>
          <ListItem
            style={{ padding: '12px 8px', width: '100%' }}
            as={WhatsappShareButton}
            url={shareUrl}
            title={shareText}
            onClick={() => onClickShareButton('whatsapp')}
          >
            <div className="flex flex-row">
              <WhatsappIcon aria-hidden className="mr-3" />
              <Text variant="heading-sm">Whatsapp</Text>
            </div>
          </ListItem>
          <ListItem
            style={{ padding: '12px 8px', width: '100%' }}
            as={FacebookShareButton}
            url={shareUrl !== ' ' ? shareUrl : shareUrls.length && shareUrls[0]}
            quote={shareText}
            onClick={() => onClickShareButton('facebook')}
          >
            <div className="flex flex-row">
              <FacebookIcon aria-hidden className="mr-3" />
              <Text variant="heading-sm">Facebook</Text>
            </div>
          </ListItem>
          <ListItem
            style={{ padding: '12px 8px', width: '100%' }}
            as={TelegramShareButton}
            url={shareUrl}
            title={shareText}
            onClick={() => onClickShareButton('telegram')}
          >
            <div className="flex flex-row">
              <TelegramIcon aria-hidden className="mr-3" />
              <Text variant="heading-sm">Telegram</Text>
            </div>
          </ListItem>
          <CopyToClipboard
            text={
              linkOnlyOnCopy
                ? linkOnlyUrl || shareUrl
                : `${shareText} ${shareUrl}`
            }
            onCopy={() => {
              toast({ message: 'Berhasil disalin', type: 'success' })
              onClickShareButton('clipboard')
            }}
          >
            <ListItem>
              <div className="flex flex-row">
                <Icon as="i" aria-hidden className="mr-3">
                  link
                </Icon>
                <Text variant="heading-sm">Salin Link</Text>
              </div>
            </ListItem>
          </CopyToClipboard>
        </List>
      </div>
    </ProfileResponsiveSheet>
  )
}
